<div class="telehealth-guide-dialog">
  <h2 mat-dialog-title class="dialog-title">Sharing tabs for Telehealth</h2>

  <mat-dialog-content class="dialog-content">
    <p class="intro-text">When you press continue, you'll see a browser dialog appear.</p>

    <ol class="instructions-list">
      <li>Select the tab from the list you want to use for Telehealth</li>
      <li>Ensure the share tab audio toggle is turned on.</li>
      <li>Click on share.</li>
    </ol>

    <p class="note-text">
      Clinical Virtual Assistant will pick up the patient audio, even if you are wearing headphones.
    </p>

    <div class="chrome-preview">
      <img [src]="previewImageSrc" alt="Share dialog preview" class="preview-image" />
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <mat-checkbox [(ngModel)]="doNotShowAgain" class="no-show-checkbox">
      Do not show this message again
    </mat-checkbox>

    <div class="action-buttons">
      <button type="button" class="cancel-btn" mat-stroked-button (click)="onCancel()">Cancel</button>
      <button type="button" class="confirm-btn" mat-flat-button color="primary" (click)="onContinue()">Continue</button>
    </div>
  </mat-dialog-actions>
</div>
